import { useEffect } from "react";
import { controlBodyScroll } from "./exportedFunctions";

export const useDisableBodyScroll = (openPopup) => {
  useEffect(
    () => controlBodyScroll(openPopup ? "hidden" : "scroll"),
    [openPopup]
  );
};
